import SearchFlights from "../features/searchFlights/SearchFlights";
import MapboxMapWrapper from "../mapbox/MapboxMapWrapper";
import React from "react";
import HeaderLogo from "./HeaderLogo";
import OAGPromoLogo from "./OAGPromoLogo";
import OAGCopyright from "./OAGCopyright";

function MTT12() {
  return (
    <div id="columns-wrapper" className="columns reverse-columns is-gapless">
      <div
        id="search-results-column"
        className="column is-one-quarter-desktop m-2"
      >
        <div
          className="is-flex is-flex-direction-column"
          style={{ height: "100%" }}
        >
          <HeaderLogo />
          <SearchFlights layout="vertical" />
          <OAGCopyright />
          <OAGPromoLogo />
        </div>
      </div>
      <div className="column">
        <div id="mapbox-wrapper">
          <MapboxMapWrapper />
        </div>
      </div>
    </div>
  );
}

export default MTT12;
